// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35490":"6e83e61f","39417":"6e83e61f","42941":"6e83e61f","80351":"6e83e61f","90408":"6e83e61f","96701":"6e83e61f","97057":"4ef0bf47"}[chunkId] + ".chunk.css";
};